<template>
  <div
    class="deal-activity-filter-submenu relative w-100 rounded-md bg-white p-0-5"
    data-cy="deal-activity-filter-submenu"
  >
    <slot />
  </div>
</template>

<style scoped>
@reference "@/assets/tailwind.css";
.deal-activity-filter-submenu :deep(.dropdown-wrapper) {
  @apply absolute! left-auto! right-0! top-[calc(100%+4px)]!;
}

.deal-activity-filter-submenu :deep(.date-filter #litepie > div) {
  @apply left-auto! right-0! top-[calc(100%+4px)]! bottom-auto! origin-top-right!;
}

.deal-activity-filter-submenu :deep(.date-filter .litepie-datepicker::before) {
  left: auto !important;
  right: 1.25rem !important;
}

/* Priority dropdown in the submenu: show label + icon per row. The inbox
   version hides labels to keep the dropdown compact; the submenu has room. */
.deal-activity-filter-submenu :deep(.priority-dropdown #exp_elem_list) {
  @apply block w-full;
}

.deal-activity-filter-submenu :deep(.priority-dropdown #exp_elem_list li) {
  @apply flex items-center justify-start gap-2 px-3 py-1-5;
}

.deal-activity-filter-submenu :deep(.priority-dropdown #exp_elem_list li span:not(.icon)) {
  @apply inline-block text-sm text-headline-new;
}
</style>
